import { FlooriThemes } from '@floori/models';

export const flooriThemes: Record<FlooriThemes, string> = {
    [FlooriThemes.default]: 'floori',
} as const;
